import { render, staticRenderFns } from "./ProductsHero.vue?vue&type=template&id=286d0d64&"
import script from "./ProductsHero.vue?vue&type=script&lang=js&"
export * from "./ProductsHero.vue?vue&type=script&lang=js&"
import style0 from "./ProductsHero.vue?vue&type=style&index=0&id=286d0d64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports